import { Withdraw } from '../../entities/Withdraw'
import { httpClient } from '../http/httpClient'

export interface WithdrawResponse {
  withdraws: Withdraw[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
    order: string
  }
}

export interface WithdrawParams {
  sellerId?: string
  startDate?: string
  endDate?: string
  search?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function withdraw(params?: WithdrawParams | undefined) {
  const { data } = await httpClient.get<WithdrawResponse>('/withdraw', {
    params,
  })

  return data
}
